<template>
    <Widget :title="$t('components.TopLocations.Title')" :info="$t('widgetsInfo.TopLocations')" :loading="loading" :report-mode="reportMode">
        <div class="d-flex mb-4 align-center" v-if="!hideControls">
            <small>List view</small>
            <v-switch class="locations-view-selector" dense v-model="mapView" />
            <small>Map view</small>
        </div>

        <LocationsMap v-if="mapView" :dataSource="dataSource"/>
        <ListChart v-if="!mapView" :items="topLocations"/>
    </Widget>
</template>

<script>
/** 
 * TopLocations contains the functions to parse and format data from 
 * the API to render a map with top chats locations.
 */

import Widget from '@/components/dashboard/Widget';

import LocationsMap from'@/components/dashboard/charts/LocationsMap';
import ListChart from'@/components/dashboard/charts/ListChart';

export default {
    name: 'TopLocations',
    data: () => ({ 
        dataSource: {},
        topLocations: [],
        mapView: true
    }),
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        chatsData: {
            type: Object,
            required: true
        },
        defaultMapView: {
            type: Boolean,
            default: true
        },
        hideControls: {
            type: Boolean,
            default: false
        },
        reportMode: {
            type: String,
            default: null
        }
    },
    mounted() {
        this.mapView = this.defaultMapView;
        this.updateDataSource(this.chatsData);
        this.topLocations = this.chatsData ? this.chatsData.topLocations : [];
    },
    methods: {
        updateDataSource(data) {
            const { locations } = data;
            const features = (!locations || locations.length === 0) ? [] : locations.map(loc => {
                const { chats, title } = loc;
                const [ long, lat ] = loc.coordinates || [0,0];
                return {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [lat, long]
                    },
                    properties: { title, chats }
                }
            });

            this.dataSource = {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features
                    },
                    cluster: true,
                    clusterMaxZoom: 13,
                    clusterRadius: 50,
                    clusterProperties: {
                        "total_chats": ["+", ["get", "chats"]]
                    }
                };
        }
    },
    watch: {
        chatsData(newData) {
            this.updateDataSource(newData);
            this.topLocations = this.chatsData ? this.chatsData.topLocations : [];
        },
        defaultMapView(mapView) {
            this.mapView = mapView;
        }
    },
    components: { Widget, LocationsMap, ListChart }
}
</script>

<style >
.locations-view-selector { margin: 0 20px 0; }
.locations-view-selector  .v-messages { display: none!important; }
</style>